const getInitial = {
  methods: {
    getInitial(user) {
      if (user) {
        return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;
      }
      return '';
    },
  },
};

export default getInitial;



// WEBPACK FOOTER //
// ./src/mixins/getInitial.js